"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBarMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react2 = require("@floating-ui/react");
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
var _useSlideTransition = require("design_system/hooks/useSlideTransition");
var _Layout = require("design_system/Layout");
var _Menu = require("design_system/Menu");
var _NavBarMenuItems = require("./NavBarMenuItems");
var _MenuContext = require("design_system/Menu/MenuContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  container: {
    position: "s768:flex flex-col",
    border: "border-gray-e7e9ef border-solid border-b-1 last:border-b-0 s768:border-none",
    bg: "bg-gray-f4f5f7 s768:bg-transparent",
    w: "w-full s768:w-auto",
    p: "py-12 px-16 s768:p-0"
  }
};
const InnerNavBarMenu = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    onOpenClose,
    ...props
  } = _ref;
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const {
    open
  } = (0, _MenuContext.useMenuContext)();
  const isNarrowScreen = width > 0 && width < _useResizeObserver.BREAKPOINTS.s768;
  const {
    ref: transitionRef,
    styles: transitionStyles,
    hidden
  } = (0, _useSlideTransition.useSlideTransition)({
    enabled: isNarrowScreen,
    open,
    durationMs: 200
  });
  (0, _react.useEffect)(() => {
    onOpenClose === null || onOpenClose === void 0 ? void 0 : onOpenClose(open);
  }, [open]);
  const mergedRefs = (0, _react2.useMergeRefs)([transitionRef, ref]);
  return /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    style: transitionStyles,
    border: THEME.container.border,
    w: THEME.container.w,
    p: THEME.container.p,
    bg: (0, _classnames.default)({
      [THEME.container.bg]: open
    }),
    className: (0, _classnames.default)(THEME.container.position, className),
    ref: mergedRefs
  }, props), _react.Children.map(children, child => {
    if (! /*#__PURE__*/(0, _react.isValidElement)(child)) {
      return null;
    }
    if (child.type === _NavBarMenuItems.NavBarMenuItems) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        ...child.props,
        className: (0, _classnames.default)(child.props.className, {
          hidden
        })
      });
    }
    return child;
  }));
});
InnerNavBarMenu.displayName = "InnerNavBarMenu";
const NavBarMenu = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    floating,
    placement,
    ...props
  } = _ref2;
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const isNarrowScreen = width > 0 && width < _useResizeObserver.BREAKPOINTS.s768;
  return /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    floating: floating || !isNarrowScreen,
    placement: placement
  }, /*#__PURE__*/_react.default.createElement(InnerNavBarMenu, _extends({}, props, {
    ref: ref
  })));
});
exports.NavBarMenu = NavBarMenu;
NavBarMenu.displayName = "NavBar.Menu";